import { cn } from '@/lib/utils';

import LinkButton from '@/components/atoms/linkButton';
import { WithRef } from '@/components/types';

import IconG2Badge from '~/svg/IconG2Badge.svg';

interface G2BadgeProps extends React.HTMLAttributes<HTMLDivElement> {
  classNames?: {
    root: string;
  };
}

export const G2Badge = ({
  classNames,
  ref,
  ...props
}: WithRef<HTMLDivElement, G2BadgeProps>) => {
  return (
    <div
      className={cn(classNames?.root)}
      ref={ref}
      data-tracker-component='g2-badge'
      {...props}
    >
      <LinkButton
        href='https://www.g2.com/products/decodo-formerly-smartproxy/reviews'
        rel='noopener noreferrer nofollow'
        target='_blank'
        slim
        variant='text'
      >
        <IconG2Badge className='text-neutral-N99' />
      </LinkButton>
    </div>
  );
};
